import { withMountWhenInView, useScroll } from "@studiometa/js-toolkit";
import { Transition } from "../../primitives/index.js";
class ScrollReveal extends withMountWhenInView(
  Transition
) {
  /**
   * Config.
   */
  static config = {
    ...Transition.config,
    name: "ScrollReveal",
    refs: ["target"],
    options: {
      ...Transition.config.options,
      enterKeep: {
        type: Boolean,
        default: true
      },
      repeat: Boolean,
      intersectionObserver: {
        type: Object,
        default: () => ({ threshold: [0, 1] })
      }
    }
  };
  /**
   * Vertical scroll direction.
   */
  static scrollDirectionY = "NONE";
  /**
   * Get the transition target.
   */
  get target() {
    return this.$refs.target ?? this.$el;
  }
  /**
   * Trigger the `enter` transition on mount.
   */
  mounted() {
    if (!this.$options.repeat) {
      this.enter();
      this.$terminate();
      return;
    }
    const scroll = useScroll();
    if (!scroll.has("ScrollRevealRepeat")) {
      scroll.add("ScrollRevealRepeat", (props) => {
        ScrollReveal.scrollDirectionY = props.direction.y;
      });
    }
    if (ScrollReveal.scrollDirectionY !== "UP") {
      this.enter();
    }
  }
}
export {
  ScrollReveal
};
//# sourceMappingURL=ScrollReveal.js.map
